/**
 * @module router/modules/mobile
 * @description 모바일 전용 라우트 모듈 — 엔지니어/대고객/스태프팀 대상의
 * 방문일정 등록·변경·확정, 접수 내역 조회, 완료 등록, 카카오네비, 취소 등
 * 모바일 웹뷰 페이지 경로를 정의합니다.
 */
const routes = [
  {
    path: '/mobile/visit-date-registration/:repairRequestId',
    name: '엔지니어 방문일정 등록 및 변경 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileVisitDateRegistration" */ '../../views/mobile/shared/MobileVisitDateRegistration.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/visit-date-registration/:repairRequestId',
    name: '토큰 모드 방문일정 등록 및 변경 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileVisitDateRegistration" */ '../../views/mobile/shared/MobileVisitDateRegistration.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/visit-date-registration/:repairStaffId/:repairRequestId',
    name: '세션 모드 방문일정 등록 및 변경 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffTeamMobileVisitDateRegistration" */ '../../views/mobile/shared/MobileVisitDateRegistration.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/customer/visit-date-change/:repairRequestId',
    name: '대고객 방문 일정 변경 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileVisitDateChangeByCustomer" */ '../../views/mobile/customer/MobileVisitDateChangeByCustomer.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/visit-date-confirm/:visitScheduleLogId',
    name: '대고객 및 엔지니어 방문 일정 확정 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileVisitDateConfirm" */ '../../views/mobile/MobileVisitDateConfirm.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/visit-date-confirm/:visitScheduleLogId',
    name: '토큰 모드 방문 일정 확정 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffMobileVisitDateConfirm" */ '../../views/mobile/shared/MobileVisitDateConfirm.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/visit-date-confirm/:repairStaffId/:visitScheduleLogId',
    name: '세션 모드 방문 일정 확정 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffTeamMobileVisitDateConfirm" */ '../../views/mobile/shared/MobileVisitDateConfirm.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff/repair-request-history/:repairStaffId',
    name: '엔지니어 접수 내역 조회 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileRepairRequestHistory" */ '../../views/mobile/staff/MobileRepairRequestHistory.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/request-completed/:repairRequestId',
    name: '엔지니어 완료 등록 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileRequestCompleted" */ '../../views/mobile/shared/MobileRepairCompleted.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/navi/:customerId',
    name: '엔지니어 카카오네비 연동 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileKakaoNavi" */ '../../views/mobile/staff/MobileKakaoNavi.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/customer/delivery/search/:repairRequestId',
    name: '대고객 접수 건 택배 조회 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileRequestDeliverySearch" */ '../../views/mobile/customer/MobileRequestDeliverySearch.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/customer/cancel/:repairRequestId',
    name: '대고객 접수 취소 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileRequestCancelByCustomer" */ '../../views/mobile/customer/MobileRequestCancelByCustomer.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/cancel/:repairRequestId',
    name: '엔지니어 접수 이관 및 취소 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileRequestProcessTypeChange" */ '../../views/mobile/staff/MobileRequestProcessTypeChange.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/visit-date/registration/result',
    name: '방문 일정 등록 결과 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileVisitDateApiResult" */ '../../views/mobile/shared/MobileVisitDateApiResult.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/visit-date/registration/result',
    name: '토큰 모드 방문 일정 등록 결과 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffMobileVisitDateApiResult" */ '../../views/mobile/shared/MobileVisitDateApiResult.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/visit-date/registration/result',
    name: '세션 모드 방문 일정 등록 결과 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffTeamMobileVisitDateApiResult" */ '../../views/mobile/shared/MobileVisitDateApiResult.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff-team/login',
    name: 'staffTeamMobileLogin',
    component: () => import(/* webpackChunkName: "staffTeamMobileLogin" */ '../../views/mobile/staffTeam/StaffTeamMobileLogIn.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/repair-request-history',
    name: 'staffTeamMobileRepairRequestHistoryAuth',
    component: () => import(/* webpackChunkName: "staffTeamMobileRepairRequestHistory" */ '../../views/mobile/staffTeam/StaffTeamMobileRepairRequestHistory.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff-team/request-completed/:repairStaffId/:repairRequestId',
    name: 'staffTeamMobileRequestCompletedAuth',
    component: () => import(/* webpackChunkName: "staffTeamMobileRequestCompleted" */ '../../views/mobile/shared/MobileRepairCompleted.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff-team/auto-assignment',
    name: 'staffTeamMobileAutoAssignmentAuth',
    component: () => import(/* webpackChunkName: "staffTeamMobileAutoAssignment" */ '../../views/mobile/staffTeam/StaffTeamMobileAutoAssignment.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff-team/assign',
    name: 'staffTeamMobileAssignAuth',
    component: () => import(/* webpackChunkName: "staffTeamMobileAssign" */ '../../views/mobile/staffTeam/StaffTeamMobileAssign.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff-team/cancel/:repairRequestId',
    name: 'staffTeamMobileProcessTypeChangeAuth',
    component: () => import(/* webpackChunkName: "staffTeamMobileProcessTypeChange" */ '../../views/mobile/staffTeam/StaffTeamMobileProcessTypeChange.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    // 카카오 웹뷰 공개 진입 — authorization:false 를 staffTeamAuth 가드가 존중 (SURINP-302, 구 FIXME 해소)
    path: '/mobile/staff-team/assign-staff/:staffTeamId',
    name: '엔지니어 배정 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileAssignStaff" */ '../../views/mobile/staffTeam/kakao/MobileAssignStaff.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff/visit-date-modify/:repairRequestId',
    name: '토큰 모드 방문일정 변경 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileVisitDateModify" */ '../../views/mobile/shared/MobileVisitDateModify.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/visit-date-modify/:repairStaffId/:repairRequestId',
    name: '세션 모드 방문일정 변경 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffTeamMobileVisitDateModify" */ '../../views/mobile/shared/MobileVisitDateModify.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff/request-detail/:repairRequestId',
    name: '토큰 모드 접수 상세 조회 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileRepairRequestDetail" */ '../../views/mobile/staff/MobileRepairRequestDetail.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/request-detail/:repairStaffId/:repairRequestId',
    name: '세션 모드 접수 상세 조회 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffTeamMobileRepairRequestDetail" */ '../../views/mobile/staffTeam/StaffTeamMobileRepairRequestDetail.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  },
  {
    path: '/mobile/staff/completed-detail/:repairRequestId',
    name: '토큰 모드 완료 상세 조회 모바일 페이지',
    component: () => import(/* webpackChunkName: "mobileCompletedDetail" */ '../../views/mobile/shared/MobileRepairCompletedDetail.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/staff-team/completed-detail/:repairStaffId/:repairRequestId',
    name: '세션 모드 완료 상세 조회 모바일 페이지',
    component: () => import(/* webpackChunkName: "staffTeamMobileCompletedDetail" */ '../../views/mobile/shared/MobileRepairCompletedDetail.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: true }
  }
]

export default routes
